import React from 'react'
import { useSnapCarousel } from 'react-snap-carousel';
import Loading from '../components/Loading'
import {isTouchDevice} from '../utils'

import PrevIcon from '../icons/prev.svg'
import NextIcon from '../icons/next.svg'


OVERFLOW = isTouchDevice ? "auto" : "hidden"

const Carousel = (props) => {
  const {items, className=''} = props 
  const {
    scrollRef,
    pages,
    activePageIndex,
    prev,
    next,
    goTo,
    snapPointIndexes
  } = useSnapCarousel();

  if (!items) {
    return (
      <Loading/>
    )
  } else {
    return (
      <div className={ "pwa__carousel " + className }>
        <ul className="pwa__carousel__container" style = {{overflow: OVERFLOW }} ref={scrollRef}>
          { items.map(
            (item, index) => (
              <li key={ index } 
                 className={ snapPointIndexes.has(index) ? "pwa__carousel__item start_point" : "pwa__carousel__item" }>
              {item}
              </li>
            )
          )}
        </ul>
        { activePageIndex != 0 && <button onClick={prev} className="pwa__carousel__prev button primary fa fade-in slow"><PrevIcon/></button> }
        { activePageIndex != pages.length -1  && <button onClick={next} className="pwa__carousel__next button primary fa fade-in slow"><NextIcon/></button>}
      </div>
    )
  }
}

export default Carousel
